import React from "react";
import styles from "./Progress.module.css";
import { LinearProgress } from "@material-ui/core";
import { useSelector } from "react-redux";

const Progress = () => {
  const status = useSelector((state) => {
    return state.progress.status;
  });

  return status ? (
    <div className={styles.container}>
      <LinearProgress color="secondary" />
    </div>
  ) : (
    <div></div>
  );
};

export default Progress;
